module.exports = __webpack_public_path__ + "image/icon_investor_info.png";